import { makeAutoObservable } from 'mobx';

import { LOCAL_STORAGE_KEY__LOCALE } from '@/constants';

export class LocaleStore {
  language = localStorage.getItem(LOCAL_STORAGE_KEY__LOCALE) || 'en';
  availableLanguages = ['en', 'fr'];

  constructor() {
    makeAutoObservable(this);
  }

  change(language) {
    if (this.availableLanguages.includes(language)) {
      localStorage.setItem(LOCAL_STORAGE_KEY__LOCALE, language);
      this.language = '';
      setTimeout(() => {
        this.language = language;
      }, 0);
    }
  }
}
